/**
 * OCR côté navigateur (Tesseract) — aucun appel Mistral pour l'extraction.
 */
export async function ocrImageInBrowser(imageDataUrl, onProgress) {
  const { createWorker } = await import("tesseract.js");
  const worker = await createWorker("fra", 1, {
    logger: (m) => {
      if (m.status === "recognizing text" && onProgress) {
        onProgress(Math.round((m.progress || 0) * 100));
      }
    },
  });

  try {
    const { data } = await worker.recognize(imageDataUrl);
    return (data?.text || "").trim();
  } finally {
    await worker.terminate();
  }
}

export function isImageDataUrl(dataUrl) {
  return typeof dataUrl === "string" && dataUrl.startsWith("data:image/");
}

export const EXTRACTION_LABELS = {
  local_pdf: "PDF (extraction locale)",
  tesseract_server: "OCR serveur (Tesseract)",
  client_ocr: "OCR navigateur (Tesseract)",
  manual: "Texte collé manuellement",
  mistral_ocr: "OCR Mistral (PDF)",
  mistral_vision: "OCR Mistral (image)",
};